import request from '@/utils/request'
import api from '../api'

export class SecuritySetting {
  changeMobile(data) {
    return request({
      url: api.securitySetting.changeMobile,
      method: 'post',
      data
    })
  }
  modifyPassword(data) {
    return request({
      url: api.securitySetting.modifyPassword,
      method: 'post',
      data
    })
  }
  forgotPassword(data) {
    return request({
      url: api.securitySetting.forgotPassword,
      method: 'post',
      data
    })
  }
  loginForgotPassword(data) {
    return request({
      url: api.securitySetting.loginForgotPassword,
      method: 'post',
      data
    })
  }
  modifyPayPassword(data) {
    return request({
      url: api.securitySetting.modifyPayPassword,
      method: 'post',
      data
    })
  }
  setPayPassword(data) {
    return request({
      url: api.securitySetting.setPayPassword,
      method: 'post',
      data
    })
  }
  bindEmail(data) {
    return request({
      url: api.securitySetting.bindEmail,
      method: 'post',
      data
    })
  }
  unbindEmail(data) {
    return request({
      url: api.securitySetting.unbindEmail,
      method: 'post',
      data
    })
  }
  verifyEmailCode(params) {
    return request({
      url: api.securitySetting.verifyEmailCode,
      method: 'get',
      params
    })
  }
  sendEmailCode(params) {
    return request({
      url: api.securitySetting.sendEmailCode,
      method: 'get',
      params
    })
  }
  enabled(data) {
    return request({
      url: api.securitySetting.enabled,
      method: 'post',
      data
    })
  }
  disabled(data) {
    return request({
      url: api.securitySetting.disabled,
      method: 'post',
      data
    })
  }
}
